



import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import { Avatar } from 'primereact/avatar';

export default function SubHeaderRowGroupDemo({ customerService, name }) {
    const [customers, setCustomers] = useState([]);
    const [expandedRows, setExpandedRows] = useState(new Set());
    const [hoveredRowKey, setHoveredRowKey] = useState(null);

    useEffect(() => {
        setCustomers(customerService || []);
    }, [customerService]); // eslint-disable-line react-hooks/exhaustive-deps

    const monthCodes = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    const monthLetters = ['E', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'];

    const toggleRow = (id) => {
        const updated = new Set(expandedRows);
        if (updated.has(id)) {
            updated.delete(id);
        } else {
            updated.add(id);
        }
        setExpandedRows(updated);
    };

    const statusToSeverity = (status) => {
        if (!status) return 'info';
        const s = String(status).toLowerCase();
        if (s.includes('liquid')) return 'success';
        if (s.includes('activo') || s.includes('vigente')) return 'warning';
        if (s.includes('mora') || s.includes('venc')) return 'danger';
        return 'info';
    };

    const topStatus = customers?.[0]?.estatus_liquidacion;


    return (
        <div
            style={{
                borderRadius: '17px',
                width: '100%',
                marginBottom: '2rem'
            }}
        >
            <div className="flex items-center justify-between" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
                <h3 style={{ fontSize: '1.5rem', fontWeight: '500', marginBottom: '1rem' }}>{name || 'Historial de Pagos'}</h3>
               
            </div>

            <Card className="overflow-hidden " style={{ border:"1px solid #b4c8f1" }}>
                <div className="overflow-x-auto">
                    <table className="w-full" style={{ 
                        borderCollapse: 'collapse', 
                        borderSpacing: '0',
                    }}>
                        <thead className={`${customers?.length > 0 ? 'bg-gray-50' : ''}`}>
                            <tr>
                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-700" style={{ borderBottom: '1px solid #e5e7eb' }}>Línea de Crédito</th>

                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-700" style={{ borderBottom: '1px solid #e5e7eb' }}>Crédito Máx.</th>
                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-700" style={{ borderBottom: '1px solid #e5e7eb' }}>Monto a Pagar</th>
                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-700" style={{ borderBottom: '1px solid #e5e7eb' }}>Último Pago</th>
                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-700" style={{ borderBottom: '1px solid #e5e7eb' }}>Saldo Vigente</th>
                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-700" style={{ borderBottom: '1px solid #e5e7eb' }}>Año</th>

                                {monthLetters.map((m, i) => (
                                    <th key={i} className="px-2 py-3 text-center text-xs font-medium text-gray-700" style={{ borderBottom: '1px solid #e5e7eb' }}>{m}</th>
                                ))}
                            </tr>       
                        </thead>
                        <tbody className="">
                            {customers?.map((line, customerIndex) => (
                                <React.Fragment key={line.id}>
                                    {line?.representative?.data?.map((yearRow, yearIndex) => (
                                        <tr
                                            key={`${line.id}-${yearRow?.anio}`}
                                            onMouseEnter={() => setHoveredRowKey(`${line.id}-${yearRow?.anio}`)}
                                            onMouseLeave={() => setHoveredRowKey(null)}
                                            style={{ 
                                                borderRadius: '17px !important',
                                                backgroundColor: customerIndex % 2 === 1 
                                                        ? '#34b9e0' 
                                                        : 'transparent',
                                                borderBottom: '1px solid #e5e7eb82',
                                              borderRadius: '17px !important',
                                            }}
                                        >
                                            <td className="py-2 px-3 ">
                                                {yearIndex === 0 && (
                                                    <div  onClick={() => toggleRow(line.id)} style={{ display: 'flex', alignItems: 'center', gap: '0.2rem' }}>
                                                        <button
                                                           
                                                            className="text-gray-400 hover:text-gray-600"
                                                            style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}
                                                        >
                                                            {expandedRows.has(line.id) ? (
                                                                <i className="pi pi-chevron-down " style={{ fontSize: '1.2rem',
                                                                    color: customerIndex % 2 === 1 ? 'white' : 'black'
                                                                 }} />
                                                            ) : (
                                                                <i className="pi pi-chevron-right " style={{ fontSize: '1.2rem',
                                                                    color: customerIndex % 2 === 1 ? 'white' : 'black'
                                                                 }} />
                                                            )}
                                                        </button> 

                                                        <div className="flex items-center gap-3" style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                                                            <div
                                                                style={{
                                                                    backgroundColor: '#2563eb',
                                                                    color: '#fff',
                                                                    width: '35px !important',
                                                                    height: '50px !important',
                                                                    minWidth: '35px',
                                                                    borderRadius: '50%',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    fontSize: '12px',
                                                                    fontWeight: 'normal',
                                                                    minHeight: '35px'
                                                                }}
                                                            >
                                                                {line?.representative?.image || (line?.representative?.name?.[0] || 'C')}
                                                            </div>
                                                            <div>
                                                                <p className="text-sm font-medium text-black">{line?.representative?.name || line?.name}</p>
                                                                {line?.representative?.descripcion && (
                                                                    <p className="text-xs text-black">{line.representative.descripcion}</p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </td>
                                            <td className="p-1 text-sm font-medium text-center text-black">{yearIndex === 0 ? (line?.valor2 || '-') : '-'}</td>
                                            <td className="p-1 text-sm font-medium text-center text-black  ">{yearIndex === 0 ? ((line?.valor && (line?.valor?.name || line?.valor)) || '-') : '-'}</td>
                                            <td className="p-1 text-sm text-center text-black   ">{yearIndex === 0 ? (line?.valor6 || '-') : '-'}</td>
                                            <td className="p-1 text-sm text-center text-black   ">{yearIndex === 0 ? (line?.valor3 || '-') : '-'}</td>
                                           {/*  <td className="p-1">
                                                {yearIndex === 0 && (
                                                    <Tag value={line?.estatus_liquidacion || line?.status} severity={statusToSeverity(line?.estatus_liquidacion || line?.status)} className="text-xs"></Tag>
                                                )}
                                            </td> */}
                                            <td className="p-1 text-sm font-medium  text-center text-black">{yearRow?.anio}</td>

                                            {monthCodes.map((code, idx) => {
                                                const val = yearRow?.[code];
                                                const hasVal = val !== undefined && val !== null && String(val).trim() !== '';
                                                return (
                                                    <td key={idx} className="px-2 py-3 text-center">
                                                        {hasVal ? (
                                                            <span
                                                                style={{
                                                                    backgroundColor: '#22c55e',
                                                                    color: '#fff',
                                                                    borderRadius: '9999px',
                                                                    width: '20px',
                                                                    height: '20px',
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    fontSize: '12px',
                                                                    fontWeight: 600
                                                                }}
                                                            >
                                                                {val}
                                                            </span>
                                                        ) : null}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    ))}

                                    {expandedRows.has(line.id) && ( 
                                        <tr className="">
                                             
                                            <td colSpan="19" className="px-4 py-4" style={{backgroundColor: customerIndex % 2 === 1 ? '#34b9e0' : 'transparent',}}>
                                                <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-200">
                                                   {/*  <div className="w-1 h-1 bg-blue-500 rounded-full"></div> */}
                                                    <h3 className="text-sm font-medium text-black" >
                                                      -  {line?.representative?.name || line?.name} - Detalles del Crédito -
                                                    </h3>
                                                </div>
                                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm px-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', gap: '1rem' }}>
                                                    <div>
                                                        <span className="text-black">Apertura:</span>
                                                        <span className="ml-2 font-medium">{` ${line?.valor5 || '-'}`}</span>
                                                    </div>
                                                    <div>
                                                        <span className="text-black">Saldo Vigente:</span>
                                                        <span className="ml-2 font-medium">{` ${line?.valor3 || '-'}`}</span>
                                                    </div>
                                                    <div>
                                                        <span className="text-black">Saldo Vencido:</span>
                                                        <span className="ml-2 font-medium">{` ${line?.valor4 || '-'}`}</span>
                                                    </div>
                                                    <div>
                                                        <span className="text-black">Clave Obs.:</span>
                                                        <span className="ml-2 font-medium">{` ${line?.valor7 || line?.clave_observacion || '-'}`}</span>
                                                    </div>
                                                    {/* Campos adicionales solo para financiero liquidado */}
                                                    {(name === 'Historial de Pagos Financiero - LIQUIDADO')  && (
                                                        <div>
                                                            <span className="text-black">Quita:</span>
                                                            <span className="ml-2 font-medium">{` ${line.quita || '-'}`}</span>
                                                        </div>
                                                    )}
                                                    {(name === 'Historial de Pagos Financiero - LIQUIDADO')  && (
                                                        <div>
                                                            <span className="text-black">Dación:</span>
                                                            <span className="ml-2 font-medium">{` ${line.dacion || '-'}`}</span>
                                                        </div>
                                                    )}
                                                    {(name === 'Historial de Pagos Financiero - LIQUIDADO')  && (
                                                        <div>
                                                            <span className="text-black">Quebranto:</span>
                                                            <span className="ml-2 font-medium">{` ${line.quebranto || '-'}`}</span>
                                                        </div>
                                                    )}
                                                    {/* Saldos vencidos por días solo para financiero activo */}
                                                    {(name === 'Historial de Pagos Financiero - ACTIVO') && (
                                                        <div>
                                                            <span className="text-black">1-29 DÍAS:</span>
                                                            <span className="ml-2 font-medium">{` ${line.saldo_vencido_de_1a29_dias || '-'}`}</span>
                                                        </div>
                                                    )}
                                                    {(name === 'Historial de Pagos Financiero - ACTIVO') && (
                                                        <div>
                                                            <span className="text-black">30-59 DÍAS:</span>
                                                            <span className="ml-2 font-medium">{` ${line.saldo_vencido_de_30a59_dias || '-'}`}</span>
                                                        </div>
                                                    )}
                                                    {(name === 'Historial de Pagos Financiero - ACTIVO') && (
                                                        <div>
                                                            <span className="text-black">60-89 DÍAS:</span>
                                                            <span className="ml-2 font-medium">{` ${line.saldo_vencido_de_60a89_dias || '-'}`}</span>
                                                        </div>
                                                    )}
                                                    {(name === 'Historial de Pagos Financiero - ACTIVO') && (
                                                        <div>
                                                            <span className="text-black">90-119 DÍAS:</span>
                                                            <span className="ml-2 font-medium">{` ${line.saldo_vencido_de_90a119_dias || '-'}`}</span>
                                                        </div>
                                                    )}
                                                    {(name === 'Historial de Pagos Financiero - ACTIVO') && (
                                                        <div>
                                                            <span className="text-black">120-179 DÍAS:</span>
                                                            <span className="ml-2 font-medium">{` ${line.saldo_vencido_de_120a179_dias || '-'}`}</span>
                                                        </div>
                                                    )}
                                                    {(name === 'Historial de Pagos Financiero - ACTIVO') && (
                                                        <div>
                                                            <span className="text-black">180+ DÍAS:</span>
                                                            <span className="ml-2 font-medium">{` ${line.saldo_vencido_de_180_dias_o_mas || '-'}`}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                     )} 
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Card>
        </div>
    );
}

